import React, { useState, useEffect, useContext } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Formik, Field } from 'formik';
import { NavigationBar, Cart } from '.';
import { SiteContext } from '../context';
import { Header } from '../screens';
import * as Yup from 'yup';

const validationSchema = Yup.object().shape({
    paymethod: Yup.string()
      .required('Choose a payment method please')
  });

const Checkout = () => {

    const { apiUrl, formatAmount, cart, getOrderTotal, manageCart, singleProduct } = useContext(SiteContext);

    const userData = JSON.parse(localStorage.getItem('user'));
    
    const [item, setItem] = useState({});
    const [cartContents, setCartContents] = useState([]);
    const [orderTotal, setOrderTotal] = useState('');
    const [msg, setMsg] = useState('');
    const [canOrder, setCanOrder] = useState(false);

    let navigate = useNavigate();
  
    useEffect(() => {
      setCartContents(cart);
      setOrderTotal(getOrderTotal);
      cart.length > 0 && setCanOrder(true);
    },[cart]);


    const handleSubmit = (values, {setSubmitting, resetForm}) => {

        let formData = new FormData();

        formData.append('productid', singleProduct ? item.id : '');
        formData.append('productname', singleProduct ? item.name : '');
        formData.append('orderdetails', singleProduct ? [] : JSON.stringify(cart));
        formData.append('amount', singleProduct ? item.price : orderTotal);
        formData.append('customerid', userData.id);
        formData.append('customername', userData.name);
        formData.append('customeremail', userData.email);
        formData.append('customerphone', userData.phone);
        formData.append('customeraddress', `${userData.address} ${userData.residencestate}`);
        formData.append('customerlatitude', userData.customerlatitude);
        formData.append('customerlongitude', userData.customerlongitude);
        formData.append('paymode', values.paymethod);
        formData.append('action', 'create');

        fetch(`${apiUrl}/api/orders.php`, {
            method: 'post',
            body: formData
        })
        .then((res) => res.json())
        .then((response) => {
            if(response.status === 200) {
                setMsg(response.msg);
                setTimeout(() => {
                  setMsg('');
                  },5000);
                  setCanOrder(false);
                  !singleProduct && manageCart('clear');
                  navigate(`/ordercomplete/${response.orderref}`, {state: {'pay': values.paymethod}});
                } else if(response.status === 400){
                setMsg(response.msg);
                setTimeout(() => {
                  setMsg('');
                  },5000);  
              }
        })
        .catch((err) => {
            alert(err)
        })
    
    }

    
    return (
        <div>
            <Header />

        <div className='container'>

        <div className='row my-3 py-3'>

        <NavigationBar section='Products' page='Checkout' goback={false} />

        <h3>Checkout</h3>

        {msg !== '' ? <div className='my-2'><span className='p-2 my-4 border border-info text-dark'>{msg}</span></div> : null}

            
            <div className='col-md-8 p-1'>
                <Cart />

                <button className='btn-light text-dark h4 my-2 py-2 rounded' onClick={() => navigate('/products')}>Keep shopping</button>

            </div>

            <div className='col-md-4 p-1'>
              {userData ? 
              <div>
                <div className='border border-secondary bg-light rounded m-2 p-3'>
                                      
                    <div className='my-2 justify-content-center align-items-center'>
                        {canOrder && <div>
                          <h5 className='my-1'>Current address</h5>
                    {userData.address}, {userData.residencestate} state <button className='btn-sm' onClick={() => navigate('/profile')}><i className='bi bi-pencil'></i> update</button>


                    <h6 className='my-2'>Estimated delivery time: 24hrs</h6>

                    <Formik
                    initialValues={{
                      paymethod:'Card'
                    }}
                    validationSchema={validationSchema}
                    onSubmit={(values, { setSubmitting, resetForm }) => {
                      handleSubmit(values, { setSubmitting, resetForm });
                    }}
                  >
                    {({
                      handleChange,
                      values,
                      handleSubmit,
                      errors,
                      isValid,
                      isSubmitting,
                      handleBlur,
                      touched,
                    }) => (
                      <form onSubmit={handleSubmit} encype="multipart/form-data">
                        <div className='row'>
                          <div className='col-md-12'>


                        <div className='form-group my-1'>
                          <label>
                          <Field type="radio" name="paymethod" value="Cash" /> Cash
                          </label>
                          <label className='px-3'>
                          <Field type="radio" name="paymethod" value="Card" /> Card
                          </label>
                        </div>

                          </div>
                        </div>
                        <button
                            style={{'width': '100%'}}
                            type='submit'
                            onClick={handleSubmit}
                            title="Submit order"
                            disabled={!isValid || isSubmitting}
                              className='btn btn-primary my-1 py-2'
                          >
                              Submit order
                          </button>
                        
                          </form>
                    )}
                  </Formik></div>}                
                    </div>
                </div>    
              </div> : 
              <div>
                  <div className="my-1 p-2 bg-info"><Cart /></div>

                <div className='d-flex justify-content-between mt-3 py-2'>
                  <Link className='btn btn-primary' to='/login'>Login to place order</Link> 
                <Link className='btn btn-secondary' to='/register'>Signup</Link>
                </div>
                
              </div>}
            </div>

            </div> 
            </div>
        </div>
    )
}

export default Checkout;